import { GalleryItemProps } from "../Gallery/GalleryItem"
import { VideoPreview } from "./VideoPreview"
import styles from "./UploadPreview.module.css";
import cn from 'clsx';

export const UploadPreview = ({ cover, coverType, className }: any) => {
    const cls = cn("object-cover", styles.preview, className);
    if (coverType === 'photo') {

        return (
            <img src={cover} alt="Image Preview" className={cls} />
        )
    }
    else {
        return (
            <VideoPreview className={cls} src={cover!} />
        )
    }
}